import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import type { NoTransferReason } from './ExperienceTransferUtils'

const ErrorPane = styled(Pane)`
  padding: ${rem(12)};
`

interface Props {
  reason: NoTransferReason
}

function ExperienceTransferBookingOptionError(props: Props) {
  const { reason } = props
  const intl = useIntl()

  const distanceBoldMessage = intl.formatMessage({
    id: 'GRAAW7inXR',
    defaultMessage: 'Sorry, there are no vehicles available for your transfer request.',
    description: 'Error message when no vehicles are available due to distance',
  })
  const passengersBoldMessage = intl.formatMessage({
    id: 'OpYtd2qvnt',
    defaultMessage: 'Sorry, there are no vehicles available for the travellers selected.',
    description: 'Error message when no vehicles are available for the number of travellers',
  })
  const childSeatsBoldMessage = intl.formatMessage({
    id: '6087VIDIg9',
    defaultMessage: 'Sorry, there are no vehicles available for the child seats selected.',
    description: 'Error message when no vehicles are available for the number of child seats',
  })
  const bagsBoldMessage = intl.formatMessage({
    id: 'cRpL7o0eTu',
    defaultMessage: 'Sorry, there are no vehicles available for the number of bags selected.',
    description: 'Error message when no vehicles are available for the number of bags',
  })

  const distanceDetailMessage = intl.formatMessage({
    id: 'JKMM/Ovlc3',
    defaultMessage: 'Please update your transfer details and try again.',
    description: 'Detail message suggesting to update transfer details after distance error',
  })
  const passengersDetailMessage = intl.formatMessage({
    id: 'YRGP6LeB/c',
    defaultMessage: 'Please update the number of travellers and try again',
    description: 'Detail message suggesting to update number of travellers',
  })
  const childSeatsDetailMessage = intl.formatMessage({
    id: 'RRv1BfiQrP',
    defaultMessage: 'Please update the number of child seats and try again',
    description: 'Detail message suggesting to update number of child seats',
  })
  const bagsDetailMessage = intl.formatMessage({
    id: 'kCAy1yP1PG',
    defaultMessage: 'Please update the number of bags and try again',
    description: 'Detail message suggesting to update number of bags',
  })

  return <ErrorPane background="neutral-seven">
    <VerticalSpacer gap={4}>
      <BodyText variant="medium" weight="bold">
        {reason === 'distance' && distanceBoldMessage}
        {reason === 'passengers' && passengersBoldMessage}
        {reason === 'childSeats' && childSeatsBoldMessage}
        {reason === 'bags' && bagsBoldMessage}
      </BodyText>
      <BodyText variant="small" colour="neutral-two">
        {reason === 'distance' && distanceDetailMessage}
        {reason === 'passengers' && passengersDetailMessage}
        {reason === 'childSeats' && childSeatsDetailMessage}
        {reason === 'bags' && bagsDetailMessage}
      </BodyText>
    </VerticalSpacer>
  </ErrorPane>
}

export default ExperienceTransferBookingOptionError
